/* eslint-disable import/prefer-default-export */

export const PRODUCT_ID_REPOSITORY = Symbol.for('PRODUCT_ID_REPOSITORY');
export const PRODUCT_DATA_REPOSITORY = Symbol.for('PRODUCT_DATA_REPOSITORY');
/**
 * @type {import('vue').InjectionKey<ProductFlags>}
 */
export const PRODUCT_FLAGS_REPOSITORY = Symbol.for('PRODUCT_FLAGS_REPOSITORY');
/**
 * @type {import('vue').InjectionKey<TopLevelCategoryFlags>}
 */
export const PRODUCT_TOP_LEVEL_CATEGORY_FLAGS_REPOSITORY = Symbol.for('PRODUCT_TOP_LEVEL_CATEGORY_FLAGS_REPOSITORY');
/**
 * @type {import('vue').InjectionKey<FeatureEligibleFlags>}
 */
export const PRODUCT_FEATURE_ELIGIBILITY_REPOSITORY = Symbol.for('PRODUCT_FEATURE_ELIGIBILITY_REPOSITORY');
export const PRODUCT_QUANTITY_REPOSITORY = Symbol.for('PRODUCT_QUANTITY_REPOSITORY');
export const PRODUCT_PRICE_REPOSITORY = Symbol.for('PRODUCT_PRICE_REPOSITORY');
